/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript !== "undefined")
		execScript(src);
	else
		eval.call(null, src);
}


/*****************
 ** WEBPACK FOOTER
 ** /home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/addScript.js
 ** module id = 1
 ** module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16
 **/